import { createContext } from "react";

export const RTableContext = createContext(
  /** @type {{columns: import(".").RTableColumn[], responsiveBreakpoint: string, isStriped: boolean}} */
  ({
    columns: [],
    responsiveBreakpoint: "500px",
    isStriped: false,
  }),
);
